import { IDateInput } from '../components';

function daysInMonth(m: number, y: number): number {
  switch (m) {
    case 2:
      return (y % 4 === 0 && y % 100 > 0) || y % 400 === 0 ? 29 : 28;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
    default:
      return 31;
  }
}

function dateObjectIsValid(d: number, m: number, y: number): boolean {
  return m >= 1 && m <= 12 && d >= 1 && d <= daysInMonth(m, y) && /[0-9]{4}/.test(y?.toString());
}

function getAge(dob: Date): number {
  const now = new Date();
  const years = now.getFullYear() - dob.getFullYear();
  const monthInYearDiff = now.getMonth() - dob.getMonth();
  const dayInMonthDiff = now.getDate() - dob.getDate();

  return monthInYearDiff > 0 || (monthInYearDiff === 0 && dayInMonthDiff >= 0) ? years : years - 1;
}

export function mapDate(value: any): Date | null {
  const date =
    typeof value === 'string'
      ? new Date(value)
      : value instanceof Date
        ? value
        : typeof value === 'object' && value?.day && value?.month && value?.year && dateObjectIsValid(value.day, value.month, value.year)
          ? new Date(value.year, value.month - 1, value.day)
          : null;
  return date;
}

export function mapDateToUtc(value: IDateInput): Date {
  const date = new Date(Date.UTC(value.year, value.month - 1, value.day, 0, 0, 0));
  return date;
}

export function dateIsValid(value: any): boolean {
  return mapDate(value) instanceof Date;
}

export function min18Years(value: any) {
  const date = mapDate(value);
  return date instanceof Date && getAge(date) >= 18;
}

export function isAgeOver(value: any, years: number): boolean {
  const date = mapDate(value);
  return date instanceof Date && getAge(date) > years;
}
